<template>
  <div id="home">
    <app-nav class="no-print" />
    <!-- 前台選單 -->
    <FrontMenu class="no-print" />
    <!-- 主要內容區 -->
    <main id="mainContent" tabindex="-1" aria-label="主要內容區">
      <div class="my-3 p-2 font text-left rounded home-div bg-white">
        <span class="landmark" title="主要內容區(快捷鍵Alt + C)">:::</span>
        <!-- 前台內容 -->
        <router-view class="pt-3 px-3 home-color" />
      </div>
    </main>
  </div>
</template>

<script>
import FrontMenu from '../components/Layout/FrontMenu'
import Nav from '../components/Layout/Nav.vue'
export default {
  name: 'home',
  components: {
    FrontMenu,
    'app-nav': Nav
  }
}
</script>

<style scoped>
.landmark {
  color: #bbb;
  font-size: 1rem;
  letter-spacing: 2px;
  margin-bottom: 3px;
  display: inline-block;
}
</style>
